// A consulta ampliada nunca concede permissoes de envio ou avaliacao.
export const UF_QUESTION_IDS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
export const NATIONAL_QUESTION_IDS = [22, 23, 24, 12, 13, 14, 15, 16, 17];

export function podeConsultarTodasEvidenciasSelo(config, groupsConfig, user, banco) {
  return /^(?:selo-sala-[a-z]{2}(?:-parceiros)?|selo-[a-z]{2}-hlg(?:-parceiros)?|selo-(?:dev(?:-analises|-parceiros)?|hlg))$/i.test(banco || "") &&
    !!user && user.habilitado !== false && !!user.grupo &&
    Number(user.grupo.usuarioGrupoId) !== 7 && user.grupo.desabilitar !== true &&
    !!config && config.visualizarTodasEvidenciasSelo === true &&
    !!groupsConfig && groupsConfig.visualizarTodasEvidenciasSelo === true;
}

export function consultaAmpliadaSomenteLeitura(question, config, groupsConfig, user, banco) {
  if (!podeConsultarTodasEvidenciasSelo(config, groupsConfig, user, banco)) return false;
  if (String(user.email || "").toLowerCase() === "admin@admin.com.br") return false;
  const nome = String(user.grupo.nome || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase();
  const ids = nome.includes("cliente oculto") ? NATIONAL_QUESTION_IDS : UF_QUESTION_IDS;
  if (!ids.includes(Number(question.perguntaId || question.PerguntaId))) return true;
  if (!nome.startsWith("avaliador")) return false;
  return !(user.permissoes || []).some(p =>
    (!Number(p.municipioId) || Number(p.municipioId) === Number(question.municipioId)) &&
    (!p.eixoId || Number(p.eixoId) === Number(question.eixoId)));
}

export const seloEvidenceReadScopeMixin = {
  methods: {
    consultaSomenteLeitura(question) {
      return consultaAmpliadaSomenteLeitura(question, this.config, this.groupsConfig, this.user, this.bancoConsultaSelo);
    },
  },
  computed: {
    consultaCompletaSelo() {
      return podeConsultarTodasEvidenciasSelo(this.config, this.groupsConfig, this.user, this.bancoConsultaSelo);
    },
  },
};
